/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2FjY2Vzc29yeS9jb21wb25lbnQvYWNjZXNzb3J5LWNvbnRyb2wvYWNjZXNzb3J5LWNvbnRyb2wuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9hY2Nlc3NvcnkvY29tcG9uZW50L2FjY2Vzc29yeS1jb250cm9sL2FjY2Vzc29yeS1jb250cm9sLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/accessory/component/accessory-control/accessory-control.component.css.shim.ngstyle.ts